(function(){
    var skLoader = function(elemId, options){
        var vm = this;
        vm.elemId = elemId;
        vm.display = display;
        vm.hide = hide;
        vm.size = 'xs';

        // setup the defaults
        init(options);
        setupDomElem();

        // initial load
        function init(options){
            if(typeof options !== 'undefined'){
                if(typeof options.size !== 'undefined'){
                    switch(options.size){
                        case 'xs':
                        case 'sm':
                        case 'md':
                        case 'lg':
                        case 'xl':
                            vm.size = options.size;
                            break;
                    }
                }
            }
        }

        function setupDomElem(){
            var html = '<div class="sk-loader sk-loader-'+vm.size+'">' +
                '<div class="sk-loader-container">' +
                '<div class="sk-loader-cube sk-loader-cube1"></div>' +
                '<div class="sk-loader-cube sk-loader-cube2"></div>' +
                '<div class="sk-loader-cube sk-loader-cube3"></div>' +
                '<div class="sk-loader-cube sk-loader-cube4"></div>' +
                '</div>' +
                '</div>';
            $(vm.elemId).append(html);
        }

        // functionality

        function display(){
            $(vm.elemId).find('.sk-loader').show();
        }

        function hide(){
            $(vm.elemId).find('.sk-loader').hide();
        }
    };
    window.skLoader = skLoader;
})();